export default "__VITE_ASSET__UopRr$Sw__"